var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSyncingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.19663 9.99023C-0.184229 10.5273 -0.00844806 11.0059 0.694677 11.0059H2.04233C2.56968 15.9766 6.85679 19.9219 11.9447 19.9219C14.9232 19.9219 17.6185 18.5645 19.4544 16.4551C19.8158 16.0352 19.7669 15.5078 19.3861 15.2344C19.0052 14.9609 18.5365 15.0586 18.224 15.4199C16.7103 17.168 14.4642 18.2617 11.9447 18.2617C7.68686 18.2617 4.22007 15.1074 3.72202 11.0059H5.1771C5.87046 11.0059 6.04624 10.5273 5.67515 10L3.48765 6.88477C3.17515 6.43555 2.7064 6.42578 2.38413 6.88477L0.19663 9.99023ZM4.44468 3.4668C4.07358 3.88672 4.12241 4.4043 4.51304 4.67773C4.8939 4.95117 5.35288 4.86328 5.67515 4.50195C7.19858 2.76367 9.44468 1.66016 11.9447 1.66016C16.1927 1.66016 19.6595 4.81445 20.1673 8.92578H18.7123C18.0189 8.92578 17.8431 9.39453 18.2142 9.93164L20.4017 13.0469C20.7142 13.4961 21.183 13.5059 21.5052 13.0469L23.683 9.94141C24.0736 9.39453 23.888 8.92578 23.1849 8.92578H21.847C21.3099 3.95508 17.0326 0 11.9447 0C8.96616 0 6.28061 1.34766 4.44468 3.4668Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncingIcon);
export default __webpack_public_path__ + "static/media/syncing_icon.f3f8269f6c2173dcdeea260d75e4a669.svg";
export { ForwardRef as ReactComponent };